import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
    {
        path: '/',
        component: () => import('@/views/home/Home'),
        hidden: true
    },
    {
        path: '/search',
        component: () => import('@/views/search/Search'),
        hidden: true
    },
    {
        path: '/login',
        component: () => import('@/views/user/Login'),
        hidden: true
    },
    {
        path: '/curriculum/:id',
        component: () => import('@/views/practice/curriculum/Curriculum'),
        hidden: true
    },
    {
        path: '/about',
        component: () => import('@/views/about/About'),
        hidden: true
    },
    {
        path: '/article/:id',
        name: 'article',
        component: () => import('@/views/article/Article'),
        hidden: true
    },
    {
        path: '/control-center',
        component: () => import('@/views/control/ControlCenter'),
        hidden: true
    },
    {
        path: '/forget-password',
        component: () => import('@/views/user/ForgetPassword'),
        hidden: true
    },
    {
        path: '/404',
        component: () => import('@/views/other/404'),
        hidden: true
    },
    {
        path: '/user',
        component: () => import('@/views/user/Center'),
        hidden: true
    },
]

const createRouter = () => new Router({
    mode: 'hash',
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
    if (to.matched.length !== 0) {
        next()
    } else {
        next({path: '/404'})
    }
});

router.afterEach(() => {
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router